import { useMutation } from "react-query";

import { api } from "../../utils/api/api";

const saveScholarshipAppField = async (
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError,
  values
) => {
  try {
    // Object.keys(values)
    //   .filter((key) => key.startsWith(`questionAnswer_dependent`)) // Do not save dependent birth year
    //   .forEach((key) => {
    //     delete values[key];
    //   });

    Object.keys(values)
      .filter((key) => key.startsWith(`questionAnswer_null`)) // Remove bad keys
      .forEach((key) => {
        delete values[key];
      });

    const formattedData = { ...values, scholarshipId };

    const returnData = await api.post(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarship_application_protected_api/updateScholarshipApplication`,
      formattedData,
      { token }
    );

    return returnData;
  } catch (err) {
    if (err?.httpStatus === 401) {
      handleInvalidToken();
    } else if (err?.httpStatus === 500) {
      handleAPIError();
    }
    throw new Error(err);
  }
};

export function useSaveScholarshipAppField(
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError
) {
  return useMutation(
    (values) => {
      return saveScholarshipAppField(
        scholarshipId,
        token,
        handleInvalidToken,
        handleAPIError,
        values
      );
    },
    {
      retry: 0,
    }
  );
}
